import { render, staticRenderFns } from "./ButtonMercadoPagoPix.vue?vue&type=template&id=2939bdb5"
import script from "./ButtonMercadoPagoPix.vue?vue&type=script&lang=js"
export * from "./ButtonMercadoPagoPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports